<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("MESSAGES.Edit offer") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="image"
            :preSelectedImage="data.image.path"
            :placeholder="$t('MESSAGES.Offer image')"
            @selectImage="selectImage"
            required
          />

          <div class="col-12">
            <router-link
              class="btn btn-primary"
              style="
                background: var(--main_theme_clr);
                color: var(--white_clr);
                border-color: var(--main_theme_clr);
              "
              :to="{
                path: '/providers/create',
                query: { type: 'offer_provider' },
              }"
            >
              {{ $t("MESSAGES.Add another provider") }}
            </router-link>
          </div>

          <base-select-input
            col="12"
            :optionsList="providers"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model="data.provider_id"
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Offer name arabic')"
            v-model.trim="data.name"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Offer name english')"
            v-model.trim="data.nameEn"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('MESSAGES.Offer description arabic')"
            v-model.trim="data.descProd"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('MESSAGES.Offer description english')"
            v-model.trim="data.descProdEn"
            required
          />
          <base-input
            col="6"
            type="date"
            :placeholder="$t('MESSAGES.Offer start date')"
            v-model.trim="data.start_date"
            required
          />
          <base-input
            col="6"
            type="date"
            :placeholder="$t('MESSAGES.Offer end date')"
            v-model.trim="data.end_date"
            required
          />
          <base-text-editor
            col="6"
            type="time"
            :placeholder="$t('MESSAGES.terms of use arabic')"
            v-model.trim="data.usage_policy_ar"
          />
          <base-text-editor
            col="6"
            type="time"
            :placeholder="$t('MESSAGES.terms of use english')"
            v-model.trim="data.usage_policy_en"
          />
          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.address')"
            v-model.trim="data.address"
            required
          />
          <div class="col-12 mb-3 input_wrapper top_label select_wrapper">
            <GmapAutocomplete
              @place_changed="setPlace"
              @keyup.enter.stop="setPlace"
              :placeholder="$t('MESSAGES.search_place')"
            />
          </div>
          <div class="col-12">
            <gmap-map
              :center="{
                lat: data.lat ?? 24.7136,
                lng: data.lng ?? 46.6753,
              }"
              :zoom="12"
              style="width: 100%; height: 300px"
              @click="setLocation($event, index)"
            >
              <gmap-marker
                v-if="data.lng && data.lat"
                :position="{
                  lat: data.lat,
                  lng: data.lng,
                }"
              />
            </gmap-map>
            <v-btn @click="resetButton" color="primary" class="mt-2">{{
              $t("PLACEHOLDERS.reset_btn")
            }}</v-btn>
          </div>
          <!-- End:: Name Input -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-4">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "EditProduct",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      providers: [],
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        lat: null,
        lng: null,
        name: null,
        nameEn: null,
        address: "",
        usage_policy_ar: null,
        usage_policy_en: null,
        start_date: null,
        end_date: null,
        provider_id: null,
        descProd: null,
        descProdEn: null,
        active: null,
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
    mostPaids() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.yes"),
          value: true,
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.no"),
          value: false,
        },
      ];
    },
  },

  methods: {
    resetButton() {
      this.data.lat = null;
      this.data.lng = null;
    },
    setLocation(event, index) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();

      this.data.lat = lat;
      this.data.lng = lng;

      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          this.data.address = results[0].formatted_address;
        } else {
          this.data.address = "--";
        }
      });
    },
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker() {
      if (this.currentPlace) {
        this.data.lat = this.currentPlace.geometry.location.lat();
        this.data.lng = this.currentPlace.geometry.location.lng();
        this.currentPlace = null;
      }
    },
    async getProviders() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "providers?limit=0&page=0&is_active=1",
        });
        this.providers = res.data.data.data;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data

      if (this.data.name) {
        REQUEST_DATA.append("name[ar]", this.data.name);
      }
      if (this.data.nameEn) {
        REQUEST_DATA.append("name[en]", this.data.nameEn);
      }
      if (this.data.descProd) {
        REQUEST_DATA.append("description[ar]", this.data.descProd);
      }
      if (this.data.descProdEn) {
        REQUEST_DATA.append("description[en]", this.data.descProdEn);
      }
      if (this.data.start_date) {
        REQUEST_DATA.append("start_date", this.data.start_date);
      }
      if (this.data.end_date) {
        REQUEST_DATA.append("end_date", this.data.end_date);
      }
      REQUEST_DATA.append("privacy[ar]", this.data.usage_policy_ar);

      REQUEST_DATA.append("privacy[en]", this.data.usage_policy_en);

      if (this.data.provider_id) {
        REQUEST_DATA.append("provider_id", this.data.provider_id?.id);
      }
      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }

      REQUEST_DATA.append("_method", "PUT");
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);
      REQUEST_DATA.append("lat", this.data.lat ?? "");
      REQUEST_DATA.append("lng", this.data.lng ?? "");
      REQUEST_DATA.append("address", this.data.address);

      try {
        await this.$axios({
          method: "POST",
          url: `offers/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/offers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    // start show data
    async showOffer() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `offers/${this.$route.params.id}`,
        });
        const offer = res.data.data.Offer;
        this.data.image.path = offer.image;
        this.data.name = offer.name_ar;
        this.data.nameEn = offer.name_en;
        this.data.descProd = offer.description_ar;
        this.data.descProdEn = offer.description_en;
        this.data.start_date = offer.start_date;
        this.data.end_date = offer.end_date;
        this.data.usage_policy_ar = offer.privacy_ar;
        this.data.usage_policy_en = offer.privacy_en;
        this.data.active = offer.is_active;
        this.data.provider_id = offer.provider;
        this.data.address = offer.address ?? "";
        this.data.lat = parseFloat(offer.lat) || null;
        this.data.lng = parseFloat(offer.lng) || null;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },

  created() {
    // Start:: Fire Methods
    this.getProviders();
    this.showOffer();
    // End:: Fire Methods
  },
};
</script>
